import Addresses from "../_ApiConn/apiAddresses";


const getAddressesByCity = async (obj) => {
    let dFromF = await Addresses.getAddressesByCity(obj);
    return (dFromF);
}



export default {
    getAddressesByCity
};